import { useJobList } from "@/constants/areas";
import { getCrowdTags } from "@/services";
import useReq from "@/utils/useReq";
import { useMemo } from "react";

export function useCrowdTags() {
  const { data } = useReq(
    async () => {
      const { jobs, industry } = await getCrowdTags();

      function map(list) {
        if (!list) {
          return null;
        }

        return list.map((item) => {
          return {
            value: item.tag_id,
            children: map(item.children),
            label: item.alias || item.title,
          };
        });
      }

      return {
        jobs: map(jobs),
        industry: map(industry),
      };
    },
    {
      cacheKey: "get_crowd_tags",
      staleTime: -1,
      cacheTime: -1,
    }
  );

  return (
    data || {
      jobs: [],
      industry: [],
    }
  );
}

export function useJobName(user: IUser) {
  const { jobs } = useCrowdTags();
  const { data: oldJobList } = useJobList();

  function findLabelByValueIterative(tree, targetValue) {
    // 使用栈来存储待处理的节点
    const stack = [...tree];
    while (stack.length > 0) {
      // 取出栈顶节点
      const currentNode = stack.pop();
      if (currentNode?.value === targetValue) {
        return currentNode.label;
      }
      if (currentNode?.children) {
        // 将子节点压入栈中
        stack.push(...currentNode.children);
      }
    }
    return null;
  }

  return useMemo(() => {
    // if (user?.extra?.market_job_tag_id) {
    //   return findLabelByValueIterative(jobs, user.extra.market_job_tag_id);
    // } else if (user?.extra?.job_id) {
    //   const job_tag_id = oldJobList.find(
    //     (item) => item.id === user.extra.job_id
    //   )?.market_job_tag_id;
    //   return findLabelByValueIterative(jobs, job_tag_id);
    // }

    return user?.profile?.data?.job || "";
  }, [jobs, oldJobList, user]);
}
